__turbopack_context__.v({
  "parent_link": "jjps6a_parent_link",
  "video_description": "jjps6a_video_description",
  "video_detail_accessibility_icons": "jjps6a_video_detail_accessibility_icons",
  "video_detail_show_title": "jjps6a_video_detail_show_title",
  "video_detail_thumbnail": "jjps6a_video_detail_thumbnail",
  "video_detail_thumbnail_container": "jjps6a_video_detail_thumbnail_container",
  "video_title": "jjps6a_video_title",
});
